// extracted by mini-css-extract-plugin
module.exports = {"img":"BlankThumbnail_img__1e1cq","imgBlank":"BlankThumbnail_imgBlank__2C1xu BlankThumbnail_img__1e1cq"};